var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}check-34`,"viewBox":"0 0 34 34"}},[_c('circle',{staticClass:"sign",attrs:{"cx":"17","cy":"17","r":"16","fill":"none","stroke-width":"2"}}),_c('path',{staticClass:"sign",attrs:{"d":"M13.5,16.5 16.5,19.5 20.5,15.5","fill":"none","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }